// VCIN Brand: Always use VCIN_COLORS from constants.js - never use Tailwind blue classes
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LogOut } from 'lucide-react';
import { VCIN_COLORS } from '../../styles/constants';

export default function AdminHeader({ companyName }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  // Get initials from email
  const getInitials = (email) => {
    if (!email) return 'A';
    const parts = email.split('@')[0].split('.');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return email.charAt(0).toUpperCase();
  };

  return (
    <header 
      className="fixed top-0 right-0 h-16 bg-white border-b border-gray-200 flex items-center justify-end px-8 z-10"
      style={{ left: '240px' }}
      data-testid="admin-header"
    >
      <div className="flex items-center gap-4">
        <div className="text-right">
          <p className="text-sm font-semibold text-gray-900">
            {user?.email?.split('@')[0] || 'Admin'}
          </p>
          <p className="text-xs text-gray-500">
            {companyName || 'Company'}
          </p>
        </div>
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm"
          style={{ backgroundColor: VCIN_COLORS.primary }}
        >
          {getInitials(user?.email)}
        </div>
        <button
          onClick={() => navigate('/signout')}
          className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-500 hover:text-red-600 hover:bg-red-50 transition-colors"
          data-testid="admin-header-logout-btn"
          title="Sign Out"
        >
          <LogOut className="w-4 h-4" />
          Sign Out
        </button>
      </div>
    </header>
  );
}
